// extracted by mini-css-extract-plugin
export default {"container":"vM-z","error":"wM-z","disabled":"xM-z","submit":"yM-z","option":"zM-z","success":"AM-z","failure":"BM-z"};